// Types
import type { Ref, ComputedRef, ShallowRef } from 'vue';

enum EConfirmationAction {
  CANCEL,
  PROCEED,
  SAVE_AND_PROCEED,
}

interface IUnsavedChangesGuardOptions<TState> {
  extractCurrentState: () => TState;
  onSave: () => Promise<boolean>;
}

interface IUnsavedChangesGuard<TState> {
  baselineState: ShallowRef<TState | null>;
  isDirty: ComputedRef<boolean>;
  showConfirmation: Ref<boolean>;
  renderKey: Ref<number>;
  snapshotState: () => void;
  interceptChange: <T>(newValue: T, applyChange: (value: T) => void) => boolean;
  handleConfirmation: (action: EConfirmationAction, onProceed: () => void) => Promise<void>;
  resetComponents: () => void;
}

export type { IUnsavedChangesGuardOptions, IUnsavedChangesGuard };

export { EConfirmationAction };
